const SUPPORTED = new Set(['en', 'cs', 'de', 'pl', 'es', 'ru']);

export const mapLocaleToCcLang = (locale: string): string => {
    const short = locale.split('-')[0];

    return SUPPORTED.has(short) ? short : 'en';
};
